/**
 * Modified from original react-super-responsive-table file "SuperResponsiveTableStyle.css" so that the mobile max-width
 * matches up with Material xs breakpoint
 */

/* inspired by: https://css-tricks.com/responsive-data-tables/ */

import { makeStyles } from '~/lib/bn-material-ui';

export default function styles(breakpoint = 'sm') {
  return makeStyles((theme) => ({
    responsiveTable: {
      'table&': {
        width: '100%',
        '& td .tdBefore': {
          display: 'none',
        },
        '@media screen': {
          [theme.breakpoints.down(breakpoint)]: {
            /*
              Force table elements to not behave like tables anymore
              Hide table headers (but not display: none;, for accessibility)
            */
            '& table, & thead, & tbody, & th, & td, & tr': {
              display: 'block',
            },
            '& thead tr': {
              position: 'absolute',
              top: -9999,
              left: -9999,
              borderBottom: '2px solid #333',
            },
            '& tbody tr': {
              border: '1px solid #000',
              padding: '.25em',
            },
            '& td.pivoted': {
              border: 'none',
              borderBottom: `1px solid ${theme.palette.gray[50]}`,
              position: 'relative',
              paddingLeft: 'calc(35% + 10px)',
              textAlign: 'left !important',
              whiteSpace: 'pre-wrap',
              overflowWrap: 'break-word',
              '&:last-child': {
                borderBottom: 'none',
              },
            },
            '& td .tdBefore': {
              /* Now like a table header */
              position: 'absolute',
              display: 'block',

              /* Top/left values mimic padding */
              left: '1rem',
              width: 'calc(50% - 20px)',
              whiteSpace: 'pre-wrap',
              overflowWrap: 'break-word',
              textAlign: 'left !important',
              fontWeight: 600,
            },
            '& tr > td': {
              borderBottom: `1px solid ${theme.palette.gray[50]} !important`,
            },
            '& tr > td:last-child': {
              borderBottom: 'none !important',
            },
          },
        },
      },
    },
  }));
}
